var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCashbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 10,
    viewBox: "0 0 22 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75 8.75H16.75C18.6356 8.75 19.5784 8.75 20.1642 8.16421C20.75 7.57843 20.75 6.63562 20.75 4.75C20.75 2.86438 20.75 1.92157 20.1642 1.33579C19.5784 0.75 18.6356 0.75 16.75 0.75H4.75C2.86438 0.75 1.92157 0.75 1.33579 1.33579C0.75 1.92157 0.75 2.86438 0.75 4.75C0.75 6.63562 0.75 7.57843 1.33579 8.16421C1.92157 8.75 2.86438 8.75 4.75 8.75Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#141B34"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.741 4.75H12.75M8.74551 4.75H8.75449M4.75 4.75H4.75897",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#141B34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashbox);
export default __webpack_public_path__ + "static/media/cashbox.a64bd59356057907b447df7520c57568.svg";
export { ForwardRef as ReactComponent };